import React from "react";
import { Chart } from "react-google-charts";

const ReflectanceChart = ({ data }) => {

	// Prepare data for Google Charts (add headers for columns)
	const chartData = [
		["Index", "Reflectance"], // Header row
		...data.map((value, index) => [index + 1, value]), // Convert reflectance to [x, y]
	];

	// Chart options
	const options = {
		title: "Reflectance",
		hAxis: {
			title: "Index",
		},
		vAxis: {
			title: "Reflectance",
		},
		legend: "none",
		series: {
			0: { color: "#1c91c0" }, // Line color
		},
	};

	return (
		<Chart
		chartType="LineChart"
		width="100%"
		height="400px"
		data={chartData}
		options={options}
		/>
	);
};

export default ReflectanceChart;
